export const areEPGEntriesEqual = (first, second) => {
  if (!first || !second) {
    return false;
  }

  return (
    first.start.title === second.start.title &&
    first.end.title === second.end.title &&
    first.title === second.title &&
    first.extraTitle === second.extraTitle &&
    (first.progressBar && second.progressBar
      ? first.progressBar.progressValue === second.progressBar.progressValue
      : !first.progressBar && !second.progressBar)
  );
};
